import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { ROUTER_PATH } from "../../common/constant";

const withCompareCondition = (WrappedComponent: any) => () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  return pathname.includes(t(ROUTER_PATH.CATEGORY)) ? (
    <WrappedComponent />
  ) : null;
};

export default withCompareCondition;
